const $ = jQuery.noConflict();

class AddTransparency {
    constructor(blog, mainHeader, mainHeaderTransp) {
        this.blog = blog;
        this.mainHeader = mainHeader;
        this.mainHeaderTransp = mainHeaderTransp;
    }
    init() {
        const mobileViewport = window.matchMedia('screen and (max-width: 991px)');
        const that = this;

        if($('body').hasClass(this.blog)) {
            if(mobileViewport.matches) {
                $(that.mainHeader).addClass(this.mainHeaderTransp);
            }
            mobileViewport.addListener((mV) => {
                if(mV.matches) {
                    $(that.mainHeader).addClass(this.mainHeaderTransp);
                }
                else {
                    if($(that.mainHeader).hasClass(this.mainHeaderTransp)) {
                        $(that.mainHeader).removeClass(this.mainHeaderTransp);
                    }
                    
                }
            })

        }
    }
}

export default new AddTransparency('blog', '.main-header', 'main-header--transparent');